import { useEffect } from "react";
// import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAction,
  deleteByIdAction,
  failedAction,
  loadedAction,
  loadMoreAction,
  refreshAction,
} from "features/pagination/paginationSlice";
import { showLoader } from "utils/loader";
import { useBackend } from "./useBackend";
import { selectAuth } from "features/auth/authSlice";

/**
 *
 * @param {*} endpoint
 * @param {*} query
 * @returns
 */
function usePaginate(endpoint, query = {}) {
  const {
    endpoint: endpointUrl,
    loadingMore,
    loadingError,
    loadingMoreError,
    loading,
    hasMore,
    items,
    total,
    needRefresh,
    skip,
  } = useSelector((state) => state.pagination);
  const dispatch = useDispatch();
  const { user } = useSelector(selectAuth);
  const { backend } = useBackend();

  // console.log(endpointUrl, endpoint);

  useEffect(() => {
    if (needRefresh || endpointUrl !== endpoint) {
      if (!loading) {
        return;
      }
      const {
        limit = user.limit,
        sortBy = "createdAt",
        sortOrder = -1,
      } = query;
      let config = {};
      const params = new URLSearchParams({
        ...query,
        limit,
        sortBy,
        sortOrder,
        skip: skip || 0,
      }).toString();

      backend()
        .get(`/${endpoint}?${params}`, config)
        .then(({ items, total }) => {
          // console.log("total", total);
          dispatch(loadedAction({ items, total, endpoint }));
        })
        .catch((e) => {
          dispatch(failedAction());
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, endpointUrl, needRefresh]);

  // useEffect(() => {
  //   clear();
  //   refresh();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [user.limit]);

  useEffect(() => {
    showLoader(loading);
  }, [loading]);

  useEffect(() => {
    if (loadingError) {
      showLoader(false);
    }
  }, [loadingError]);

  function loadMore() {
    const { limit = user.limit, sortBy = "createdAt", sortOrder = -1 } = query;
    // when "skip" changes, we update our query
    let config = {
      loader: true,
      msg: {
        loading: "Loading more...",
        success: "Loaded successfully.",
      },
    };
    // console.log('useNestPaginate', state)
    const params = new URLSearchParams({
      ...query,
      limit,
      sortBy,
      sortOrder,
      skip: skip || 0,
    }).toString();

    dispatch(loadMoreAction());
    backend()
      .get(`/${endpoint}?${params}`, config)
      .then(({ items, total }) => {
        dispatch(loadedAction({ items, total, endpoint }));
        console.log("total", total);
      })
      .catch((e) => {
        dispatch(failedAction());
      });
  }

  const refresh = () => {
    dispatch(refreshAction());
  };

  const deleteById = (id) => {
    dispatch(deleteByIdAction({ id }));
  };

  const clear = () => {
    dispatch(clearAction());
  };

  useEffect(() => {
    return () => {
      dispatch(clearAction());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    loadingMore,
    loadingError,
    loadingMoreError,
    loading,
    hasMore,
    items,
    total,
    loadMore,
    refresh,
    deleteById,
    clear,
  };
}

// usePaginate.prototype = {
//   endpoint: PropTypes.string.isRequired,
//   query: PropTypes.object.isRequired,
// };

// // Set default props
// usePaginate.defaultProps = {
//   query: { limit: 20, sortBy: "createdAt", sortOrder: -1 },
// };

export { usePaginate };
